import { memo } from 'react';

import { GamificationRankingData } from '@common/types/api';
import { Avatar } from '@components';

import * as S from './styles';

type RankingCardProps = GamificationRankingData & {
  position: number;
};

const RankingCard = (props: RankingCardProps) => {
  const { info_user, total, user, position } = props;
  const { avatar, name } = user.data;

  return (
    <S.Container>
      <S.Position $position={position}>
        {position > 3 ? position : null}
      </S.Position>

      <Avatar src={avatar} alt={name} />

      <S.UserInfo>
        <strong>{name.split(' ')[0]}</strong>
        <span>{info_user}</span>
      </S.UserInfo>

      <S.ScorePill $position={position}>{`${total} pts`}</S.ScorePill>
    </S.Container>
  );
};

export default memo<RankingCardProps>(
  RankingCard,
  (prevProps, nextProps) =>
    prevProps.user_id === nextProps.user_id &&
    prevProps.total === nextProps.total &&
    prevProps.position === nextProps.position,
);
